<template>
  <div class="work">
    <project-preview v-for="(project, index) in projects" :project="project" :key="index"></project-preview>
  </div>
</template>

<script>
import ProjectPreview from './Preview.vue'
import projects from '../../projects'

export default {
  name: 'work-overview',
  data () {
    return {
      projects: projects
    }
  },
  components: {
    ProjectPreview
  }
}
</script>

<style lang="sass">

@import "../../assets/sass/utilities/variables"
@import "../../assets/sass/utilities/mixins"

.work
  width: 100%
  padding-bottom: 25px
  padding-top: 50px
  display: flex
  flex-flow: row wrap
  +medium
    padding-top: 110px

</style>





// WEBPACK FOOTER //
// Overview.vue?2a052741